import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme, ) => ({   
  contentBlock: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    },
  },
  roomWrapper: {
    flex: 1,
    marginTop: theme.spacing(3),
  },
}));
